export enum InviteKind {
    Dm = "dm",
    Invite = "invite",
    // NB. This dialog needs the 'mx_InviteDialog_transferWrapper' wrapper class to have the correct
    // padding on the bottom (because all modals have 24px padding on all sides), so this needs to
    // be passed when creating the modal
    // CallTransfer = "call_transfer",
}
